export const enum ASYNC_DATA_KEYS {
  // Product
  PRODUCT_PENALTY = 'product_penalty',
  CURRENCY_PRODUCT_INFO = 'currency-product-info',

  // Booking
  GIFT_REMARKS = 'gift-remarks',

  // Auth
  FB_LOGIN = 'fb-login',

  // Region Pages
  THEME_PAGE_DATA = 'theme-page-data',
  CATEGORY_PAGE_DATA = 'category-page-data',
  SEARCH_PAGE_DATA = 'search-page-data',
}

function getCurrentLocale() {
  try {
    const locale = useNuxtApp().$i18n?.locale

    if (typeof locale === 'string') {
      return locale
    }

    if (locale && typeof locale === 'object' && 'value' in locale) {
      const localeRef = locale as Record<'value', unknown>

      return localeRef.value ? String(localeRef.value) : ''
    }

    return ''
  } catch {
    return ''
  }
}

export const getAsyncDataKey = (baseKey: string, params: (string | number)[] = []) => {
  const keyParts = [baseKey, ...params.map(String), getCurrentLocale()].filter(Boolean)

  return keyParts.join('_')
}
